// single source of truth for how roles render in the UI.
//
// two audiences, intentionally different:
//
//   internal  — the viewer is seeing their own role, or is an admin on an
//               admin-only surface. internal role names (SYS ADMIN, etc)
//               are fine here and help staff debug / cross-reference.
//
//   customer  — a non-admin user is seeing *someone else's* role. never
//               expose internal taxonomy; 'admin' reads as "Support" with
//               a life-ring. used on ticket comments, announcement author
//               attributions, anywhere a customer can see a role chip.
//
// when adding a new role, update the ROLES list below and both the
// internal and customer columns so both surfaces stay in sync.

const ROLES = [
  // 'admin' is Initek staff. Internal label is fine because sys-admins are the
  // only ones who see their own role label. Customer label masks to 'Support'
  // so no customer surface leaks "Sys Admin" terminology.
  { id: 'admin',             internalLabel: 'SYS ADMIN',         customerLabel: 'Tech Support',    internalIcon: 'fa-shield',           customerIcon: 'fa-life-ring' },
  // 'customer-admin' is the tenant-side admin. It displays as 'Fleet Admin'
  // everywhere (internal AND customer) — never "Admin" alone on a
  // customer-visible surface, because that name collides with the internal
  // Sys Admin role. ('tbn-admin' was a second, TBN-only spelling of this same
  // tier; it was retired -- TBN fleet admins use 'customer-admin'.)
  { id: 'customer-admin',    internalLabel: 'FLEET ADMIN',       customerLabel: 'Fleet Admin',     internalIcon: 'fa-cogs',             customerIcon: 'fa-cogs' },
  { id: 'customer',          internalLabel: 'STAFF',             customerLabel: 'Staff',           internalIcon: 'fa-user',             customerIcon: 'fa-user' },
  { id: 'booking-customer',  internalLabel: 'BOOKING CUSTOMER',  customerLabel: 'Booking Customer', internalIcon: 'fa-calendar-check-o', customerIcon: 'fa-calendar-check-o' },
  { id: 'driver',            internalLabel: 'DRIVER',            customerLabel: 'Driver',          internalIcon: 'fa-id-badge',         customerIcon: 'fa-id-badge' },
  { id: 'customer-care',     internalLabel: 'CUSTOMER CARE',     customerLabel: 'Customer Care',   internalIcon: 'fa-headphones',       customerIcon: 'fa-headphones' },
  { id: 'manager',           internalLabel: 'MANAGER',           customerLabel: 'Manager',         internalIcon: 'fa-briefcase',        customerIcon: 'fa-briefcase' },
  { id: 'dispatch',          internalLabel: 'DISPATCH',          customerLabel: 'Dispatch',        internalIcon: 'fa-compass',          customerIcon: 'fa-compass' },
  { id: 'garage',            internalLabel: 'GARAGE',            customerLabel: 'Garage',          internalIcon: 'fa-wrench',           customerIcon: 'fa-wrench' },
  { id: 'wash-bay',          internalLabel: 'WASH BAY',          customerLabel: 'Wash Bay',        internalIcon: 'fa-tint',             customerIcon: 'fa-tint' },
]

const _byId = {}
for (const r of ROLES) _byId[r.id] = r

const OTHER = { internalLabel: 'OTHER', internalIcon: 'fa-circle-o' }

export function roleLabelForInternal(role) {
  const r = _byId[role]
  if (r) return r.internalLabel
  return role ? String(role).toUpperCase() : 'UNKNOWN'
}

export function roleIconForInternal(role) {
  const r = _byId[role]
  return r ? r.internalIcon : OTHER.internalIcon
}

export function roleLabelForCustomer(role) {
  const r = _byId[role]
  return r ? r.customerLabel : ''
}

export function roleIconForCustomer(role) {
  const r = _byId[role]
  return r ? r.customerIcon : ''
}
